import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ behavior = "instant" }) {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // disattiva il ripristino automatico del browser
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // se l'indirizzo punta a un'ancora (es. #tinder-form), scorri fino a quel
    // punto invece che in cima: aspetta un istante che la pagina nuova sia
    // renderizzata prima di cercare l'elemento
    if (hash) {
      const id = hash.replace("#", "");
      const scrollToTarget = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior, block: "start" });
          return true;
        }
        return false;
      };

      if (!scrollToTarget()) {
        const timeout = setTimeout(scrollToTarget, 50);
        return () => clearTimeout(timeout);
      }
      return;
    }

    // altrimenti vai in alto ad ogni cambio rotta (anche querystring)
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [pathname, search, hash, behavior]);

  return null;
}
